import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Разделы смены
export const SHIFT_SECTIONS = {
    SETTINGS: 'settings',
    TEAMS: 'teams',
    EVENTS: 'events',
    GAMES: 'games',
    BROADCAST: 'broadcast'
};

// Конфигурация под-табов для каждой игры
export const GAME_TABS_CONFIG = {
    DOZOR: [
        { id: 'edit', label: 'Редактирование' },
        { id: 'manage', label: 'Управление' }
    ],
    LEGEND: [
        { id: 'edit', label: 'Редактирование' }
    ],
    KILLER: [
        { id: 'edit', label: 'Редактирование' }
    ],
    DEMOCRACY: [
        { id: 'questions', label: 'Вопросы' },
        { id: 'sanctions', label: 'Санкции' },
        { id: 'manage', label: 'Управление' },
        { id: 'bundle', label: 'Bundle' }
    ],
    FAIR: [
        { id: 'edit', label: 'Редактирование' }
    ],
    NEIGHBOR: [
        { id: 'main', label: 'Основная' },
        { id: 'tasks', label: 'Задания' },
        { id: 'codes', label: 'Коды' },
        { id: 'templates', label: 'Шаблоны' }
    ],
    BET: [
        { id: 'edit', label: 'Редактирование' }
    ],
    TEAM_TASK: [
        { id: 'edit', label: 'Редактирование' },
        { id: 'manage', label: 'Управление' }
    ]
};

// Глобальные view приложения
export const APP_VIEWS = {
    SHIFTS: 'shifts',
    ORGANIZERS: 'organizers',
    CAMP_SETTINGS: 'camp_settings'
};

const useTabsNavigationStore = create(
    persist(
        (set, get) => ({
            // Текущий глобальный view
            currentView: APP_VIEWS.SHIFTS,

            // Выбранный сезон
            selectedSeason: null,

            // Выбранная смена (id)
            selectedShiftId: null,

            // Выбранный раздел смены
            selectedSection: SHIFT_SECTIONS.SETTINGS,

            // Выбранная игра (для раздела Игры)
            selectedGame: null,

            // Выбранный под-таб игры
            selectedGameTab: null,

            // Выбранная команда (для раздела Команды)
            selectedTeam: null,

            // ID смены, ожидающей выбора после обновления списка
            pendingShiftId: null,

    // Переключить на view организаторов
    showOrganizers: () => set({ currentView: APP_VIEWS.ORGANIZERS }),

    // Переключить на настройки лагеря
    showCampSettings: () => set({ currentView: APP_VIEWS.CAMP_SETTINGS }),

    // Вернуться к сменам
    showShifts: () => set({ currentView: APP_VIEWS.SHIFTS }),

    // Установить сезон
    setSeason: (season) => {
        set({
            selectedSeason: season,
            selectedShiftId: null,
            selectedSection: SHIFT_SECTIONS.SETTINGS,
            selectedGame: null,
            selectedGameTab: null,
            selectedTeam: null
        });
    },

    // Установить смену
    setShift: (shiftId) => {
        set({
            selectedShiftId: shiftId,
            selectedSection: SHIFT_SECTIONS.SETTINGS,
            selectedGame: null,
            selectedGameTab: null,
            selectedTeam: null
        });
    },

    // Установить смену с сезоном (для новых смен)
    setShiftWithSeason: (shiftId, season) => {
        set({
            selectedSeason: season,
            selectedShiftId: shiftId,
            selectedSection: SHIFT_SECTIONS.SETTINGS,
            selectedGame: null,
            selectedGameTab: null,
            selectedTeam: null,
            pendingShiftId: null
        });
    },

    // Установить ожидающую смену (после создания, до обновления списка)
    setPendingShift: (shiftId) => {
        set({ pendingShiftId: shiftId });
    },

    // Очистить ожидающую смену
    clearPendingShift: () => {
        set({ pendingShiftId: null });
    },

    // Установить раздел смены
    setSection: (section) => {
        set({
            selectedSection: section,
            selectedGame: null,
            selectedGameTab: null,
            selectedTeam: null
        });
    },

    // Установить игру
    setGame: (gameType) => {
        const tabs = GAME_TABS_CONFIG[gameType];
        set({
            selectedGame: gameType,
            selectedGameTab: tabs?.[0]?.id || null
        });
    },

    // Установить под-таб игры
    setGameTab: (tabId) => {
        set({ selectedGameTab: tabId });
    },

    // Установить команду
    setTeam: (teamId) => {
        set({ selectedTeam: teamId });
    },

    // Сбросить навигацию
    reset: () => {
        set({
            selectedSeason: null,
            selectedShiftId: null,
            selectedSection: SHIFT_SECTIONS.SETTINGS,
            selectedGame: null,
            selectedGameTab: null,
            selectedTeam: null
        });
    }
        }),
        {
            name: 'tabs-navigation',
            partialize: (state) => ({
                currentView: state.currentView,
                selectedSeason: state.selectedSeason,
                selectedShiftId: state.selectedShiftId,
                selectedSection: state.selectedSection,
                selectedGame: state.selectedGame,
                selectedGameTab: state.selectedGameTab,
                selectedTeam: state.selectedTeam
            })
        }
    )
);

export default useTabsNavigationStore;
